import { graphql } from "~/gql";

export const COPY_SCOPE = graphql(/* GraphQL */ `
  mutation copyScope($scopeMatterId: Int!, $targetMatterId: Int!) {
    copyScope(scopeMatterId: $scopeMatterId, targetMatterId: $targetMatterId) {
      id
      phases {
        title
        order
        description
        tasks {
          id
          phaseId
          title
          order
        }
      }
    }
  }
`);
